import React from 'react';
import { 
  HelpCircle, 
  Home, 
  Calendar, 
  FileText, 
  Shield, 
  Briefcase, 
  PiggyBank,
  Wallet,
  Clock
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами по налоговым вычетам
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Home,
      title: 'Имущественный вычет',
      description: 'Вычет при покупке жилья предоставляется один раз в жизни. Выбирайте момент для его использования с максимальной выгодой.'
    },
    {
      icon: Calendar,
      title: 'Срок давности',
      description: 'Вы можете получить вычет за последние 3 года. Не упустите возможность вернуть НДФЛ за прошедшие периоды.'
    },
    {
      icon: FileText,
      title: 'Документы',
      description: 'Подготовьте полный комплект документов, подтверждающих расходы. Сохраняйте договоры, чеки, платежные поручения.'
    },
    {
      icon: Briefcase,
      title: 'Работодатель',
      description: 'Вы можете получить вычет через работодателя, не дожидаясь окончания года. Это удобно для крупных вычетов.'
    },
    {
      icon: PiggyBank,
      title: 'Вычет по ИИС',
      description: 'Для получения инвестиционного вычета типа А необходимо держать счет не менее 3 лет без выводов средств.'
    },
    {
      icon: Clock,
      title: 'Социальные вычеты',
      description: 'Вычеты на лечение и обучение необходимо использовать в год расходов - они не переносятся на следующие периоды.'
    },
    {
      icon: Wallet,
      title: 'Ограничение вычета',
      description: 'Сумма возврата НДФЛ не может превышать сумму уплаченного вами налога за год.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-emerald-500" />
        Советы по налоговым вычетам
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Shield className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Консультация специалиста
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Для сложных ситуаций с налоговыми вычетами рекомендуем проконсультироваться с налоговым специалистом.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Найти консультанта
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;